export default function GuideKeyResults() {
  return (
    <>
      <h2 className="wg_title">
        <img src="/images/question_icon.svg" />
        What are key results
      </h2>
      <p className="wg_caption">
        Specific, measurable outcomes that track progress towards a job or
        role’s objectives, often monitored short-term through scorecards.
      </p>

      <div className="guide_sections">
        <div className="guide_card greenBorder">
          <h6> How to define </h6>
          <ul>
            <li>
              Specify measurable outcomes, and think about the controllable
              activities that can be measured.
            </li>
            <li>
              Each key result should clearly track progress towards an
              objective.
            </li>
            <li>
              Make sure they are specific, measurable, achievable, relevant, and
              time-bound (SMART).
            </li>
          </ul>
        </div>
        <div className="guide_card orangeBorder">
          <h6> Examples </h6>
          <ul>
            <li>Calls made this week</li>
            <li>Days shipped on time</li>
            <li>New warm leads this week</li>
            <li>Cycle counts made</li>
          </ul>
        </div>
      </div>
    </>
  );
}
